<div *ngIf="currentUser" nz-row class="header-wrapper">

  <button id="back-dash-mobile" nz-button *ngIf="rightView != 'personalData'" nzShape="circle" nzType="default"
    (click)="onChooseAction('personalData')">
    <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
  </button>

  <img class="logo-header" src="assets/img/teamsystem.png" />

  <button id="side-trigger" nz-button nzShape="circle" nzType="default" (click)="open()">
    <i nz-icon nzType="user" nzTheme="outline"></i>
  </button>
  <nz-drawer id="side-drawer" nzClosable="true" [nzVisible]="visible" nzPlacement="right" [nzTitle]="sidenavHeader"
    (nzOnClose)="close()">
    <ng-container *nzDrawerContent>

      <nz-divider nzText="Identità utente" nzOrientation="left"></nz-divider>

      <app-identity-list [user]="currentUser" [identities]="currentUser?.identities">
      </app-identity-list>

      <nz-divider nzText='{{currentUser.first_name}} {{currentUser.last_name}}' nzOrientation="left"></nz-divider>

      <ul nz-menu>
        <li nz-menu-item *ngIf="canShowRequestButton()">
          <a (click)="changeView('requests')">
          <i nz-icon nzType="solution" nzTheme="outline"></i>
          Richieste</a>
        </li>
        <li nz-menu-item *ngIf="canShowRequestButton()">
          <a (click)="changeView('draft')">
          <i nz-icon nzType="profile" nzTheme="outline"></i>
          Bozze</a>
        </li>
        <li nz-menu-item>
          <a (click)="onChangePassword()">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            Modifica password</a>
        </li>
        <li nz-menu-item>
          <a (click)="logout()">
            <i nz-icon nzType="poweroff" nzTheme="outline"></i>
            <ng-container i18n="Generic.SignOut|label for sign out@@Generic.SignOut">
              Esci
            </ng-container>
          </a>
        </li>
      </ul>

    </ng-container>
  </nz-drawer>
  <ng-template #sidenavHeader>
    <div class="logo mobile">
      <img src="assets/img/teamsystem.png" />
    </div>
  </ng-template>


  <div id="user-data">
    <a nz-dropdown nzTrigger="click" nzPlacement="bottomRight" [nzDropdownMenu]="usermenu">
      <!--<nz-avatar nzIcon="user"
        nzSrc="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1834&q=80" style="margin-right: 1rem">
      </nz-avatar>-->
      <span style="margin-right: 1rem">{{currentUser.first_name}} {{currentUser.last_name}}</span>
      <i nz-icon nzType="down"></i>
    </a>
    <nz-dropdown-menu #usermenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item>
          <a (click)="onChangePassword()">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            Modifica password</a>
        </li>
        <li nz-menu-item>
          <a (click)="logout()">
            <i nz-icon nzType="poweroff" nzTheme="outline"></i>
            <ng-container i18n="Generic.SignOut|label for sign out@@Generic.SignOut">
              Esci
            </ng-container>
          </a>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>

<app-modify-password [events]="onModifyPasswrdEventSubject.asObservable()"></app-modify-password>
